import { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  Dialog,
  DialogContent,
} from "@mui/material";
import axios from "axios";
import { Close } from "@mui/icons-material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { toast } from "react-toastify";
import moment from "moment";

const Supplier = () => {
  const [supplier, setSupplier] = useState([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [open, setOpen] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [opendel, setOpenDel] = useState(false);
  const [id, setId] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState(false);
  const [file, setFile] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  useEffect(() => {
    getAllSupplier(0, "");
  }, []);

  const getAllSupplier = (page, search) => {
    const data = {
      page: page,
      limit: 10,
      searchChar: search,
    };
    axios
      .post(process.env.REACT_APP_BACKEND + "get-supplier", data, {
        headers: { Authorization: `Bearer ${localStorage?.getItem("token")}` },
      })
      .then((resp) => {
        setSupplier(resp && resp.data && resp.data.data);
        setCount(resp && resp.data && resp.data.totalcount);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const columns = [
    {
      name: "Supplier_ID",
      label: " Supplier Code",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Plant_ID",
      label: "Plant Code",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Plant_Name",
      label: "Plant Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "SuListing_Filter_Searchpage_Years_Of_Operation",
      label: "Years of Operation",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "createdAt",
      label: "Created Date",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return value ? moment(value).format("DD-MM-YYYY") : "-";
        },
      },
    },
    {
      name: "updatedAt",
      label: "Updated Date",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return value ? moment(value).format("DD-MM-YYYY") : "-";
        },
      },
    },
    {
      name: "Action",
      label: "Action",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="Delete Supplier">
                <IconButton
                  aria-label="delete Supplier"
                  onClick={() => handleOpen(supplier[dataIndex]?._id, "delete")}
                >
                  <DeleteOutlineOutlinedIcon className="fs-20 delete-icon" />
                </IconButton>
              </Tooltip>
              {/* <Tooltip title="Edit Supplier">
                <IconButton
                  aria-label="Edit Supplier"
                  onClick={() =>
                    handleOpen(
                      supplier[dataIndex]?._id,
                      "edit",
                      supplier[dataIndex]?.status
                    )
                  }
                >
                  <Edit />
                </IconButton>
              </Tooltip> */}
            </>
          );
        },
      },
    },
  ];
  //option for mui datatable
  const options = {
    responsive: "standard",
    download: false,
    selectableRows: "multiple",
    filter: false,
    viewColumns: false,
    serverSide: true,
    count: count,
    sort: true,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        getAllSupplier(tableState.page, "");
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      getAllSupplier(page, searchText);
    },
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      const ids = rowsSelected.map((rowIndex) => supplier[rowIndex]?._id); // Handle undefined rows
      setSelectedIds(ids);
    },
    customToolbarSelect: () => null,
  };
  //Function to make dailog box open and set the state
  const handleOpen = (supplier, type, status) => {
    if (type === "delete") {
      setId(supplier);
      setOpenDel(true);
    } else if (type === "edit") {
      setId(supplier);
      setOpen(true);
      setType("edit");
      setStatus(status);
    } else if (type === "upload") {
      setOpenUpload(true);
      setType("upload");
    }
  };

  //Function to make close the dailog box close
  const handleClose = () => {
    setOpen(false);
    setOpenDel(false);
    setType("");
    setFile("");
    setStatus(false);
    setId("");
    setSelectedIds([]);
    setOpenUpload(false);
  };

  //
  const handleSubmit = () => {
    if (type === "edit") {
      const data = {
        id: id,
        status: !status,
      };
      axios
        .post(process.env.REACT_APP_BACKEND + "update-supplier", data, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem("token")}`,
          },
        })
        .then((resp) => {
          toast.success(resp && resp.data && resp.data.msg);
          getAllSupplier(page, "");
          handleClose();
        })
        .catch((err) => {
          toast.error(
            err && err.response && err.response.data && err.response.data.msg
          );
          handleClose();
        });
    } else if (type === "upload") {
      let formData = new FormData();
      formData.append("file", file);

      axios
        .post(process.env.REACT_APP_BACKEND + "create-supplier", formData, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem("token")}`,
          },
        })
        .then((resp) => {
          toast.success(resp && resp.data && resp.data.msg);
          getAllSupplier(0, "");
          handleClose();
        })
        .catch((err) => {
          toast.error(
            err && err.response && err.response.data && err.response.data.msg
          );
          handleClose();
        });
    } else {
      const data = {
        ids: selectedIds.length > 0 ? selectedIds : [id],
      };

      axios
        .post(process.env.REACT_APP_BACKEND + "delete-supplier", data, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem("token")}`,
          },
        })
        .then((resp) => {
          toast.success(resp && resp.data && resp.data.msg);
          getAllSupplier(page, "");
          handleClose();
        })
        .catch((err) => {
          toast.error(
            err && err.response && err.response.data && err.response.data.msg
          );
          handleClose();
        });
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files[0];
    setFile(files);
  };
  return (
    <div className="p-4">
      <div
        className="mb-5"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2 className="primary_title text-start about_heading m-2 mb-3">
          Supplier Management
        </h2>
        <div>
          {selectedIds.length > 0 && (
            <Button className="borderbtn" onClick={handleSubmit}>
              Delete Selected
            </Button>
          )}
          <Button
            variant="contained"
            className="btn ms-4"
            onClick={() => handleOpen("", "upload")}
          >
            Upload CSV
          </Button>
        </div>
      </div>
      <MUIDataTable data={supplier} columns={columns} options={options} />

      {/* Dialog box foe create and edit  */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
      >
        <div className="d-flex justify-content-between align-items-center p-3">
          <h3 className="mb-0">Edit Supplier Status</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14 fw-500">
            {status
              ? "Are sure want to Inactive Supplier.?"
              : "Are sure want to Active Supplier.?"}
          </p>
          <div className="text-center mt-4">
            <Button
              variant="outlined"
              className="borderbtn"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="btn ms-4"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* Dialog box to delete   */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-items-center p-3">
          <h3 className="mb-0">Delete Supplier</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14 fw-500">
            Are you sure you want to delete the Supplier ?
          </p>
        </DialogContent>

        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="btn ms-4"
            onClick={handleSubmit}
          >
            Delete
          </Button>
        </div>
      </Dialog>
      {/* Dialog box to Upload*/}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={openUpload}
      >
        <div className="d-flex justify-content-between align-items-center p-3">
          <h3 className="mb-0">Upload Supplier</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <div className="m-auto text-center">
            <input
              type="file"
              id="cda"
              onChange={handleFileChange}
              multiple // Allows multiple file selection if needed
            />
          </div>
        </DialogContent>

        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className=" btn ms-4"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default Supplier;
